export let PERMISSIONS_SCHEMA = [];
export let FLAT_SCHEMA = {};
//This will work as a relations map
export let parentMap = {};

//Create a dictionary from the schema
const flattenSchema = (items, parent = null) => {
    items.forEach(item => {
        FLAT_SCHEMA[item.name] = item;
        //Fill the parentMap if current item has children
        if (parent) parentMap[item.name] = parent;
        //Calls itself to repeat the process if there's children. Skip a custom role's own children:
        //they're synthetic leaves named after raw action codes, not real selectable schema nodes,
        //and flattening them creates phantom FLAT_SCHEMA entries that can never be unchecked.
        if (item.children && !item.is_custom) flattenSchema(item.children, item.name);
    })
}

export const setDynamicSchema = (schema) => {
    //Clean old data
    PERMISSIONS_SCHEMA.length = 0;
    Object.keys(FLAT_SCHEMA).forEach(k => delete FLAT_SCHEMA[k]);
    Object.keys(parentMap).forEach(k => delete parentMap[k]);

    schema.forEach(item => PERMISSIONS_SCHEMA.push(item));

    flattenSchema(PERMISSIONS_SCHEMA);
}

//Set all checkboxes to "false"
const getInitialState = () => Object.keys(FLAT_SCHEMA).reduce((acc, key) => ({...acc, [key]: false}), {});

//Recursively collect every descendant name (not just direct children), needed to mark/unmark nested groups
export const getAllDescendantNames = (item) => {
    if (!item.children) return [];

    return item.children.flatMap(child => [child.name, ...getAllDescendantNames(child)]);
}

//Recursively collect only leaf descendant names (items with actions), used to compute a group's checked state
export const getLeafDescendantNames = (item) => {
    if (!item.children) return item.actions ? [item.name] : [];

    return item.children.flatMap(getLeafDescendantNames);
}

//True if targetName is item itself or is nested anywhere under it
export const containsDescendant = (item, targetName) => {
    if (item.name === targetName) return true;
    if (!item.children) return false;

    return item.children.some(child => containsDescendant(child, targetName));
}

export const actionsToState = (schema, activeActions = []) => {
    const state = getInitialState();
    if (!activeActions.length) return state;

    //Mark leaves
    Object.values(FLAT_SCHEMA).forEach(item => {
        //Search for matching permissions, if a match is found, the checkbox will be "true"
        if (item.actions?.some(action => activeActions.includes(action))) {
            state[item.name] = true;
        }
    });

    const updateParents = () => {
        let changed = false;
        
        //Check if the children are marked, and mark the parent if they are
        Object.keys(parentMap).forEach(childName => {
            const parentName = parentMap[childName];
            const children = FLAT_SCHEMA[parentName].children;
            const allChecked = children.every(child => state[child.name]);

            if (state[parentName] !== allChecked) {
                state[parentName] = allChecked;
                changed = true;
            }
        });
        //Ensure the "grandfather" is marked as well
        if (changed) updateParents();
    };
    updateParents();
    return state;
};

export const extractPermissions = (schema, checkedRoles) => {
    const actions =  Object.values(FLAT_SCHEMA)
        .filter(item => item.actions && checkedRoles[item.name])    //Search for items marked by the user
        .flatMap(item => item.actions)  //Extracts the actions of the matched item

    return [...new Set(actions)]
}